import React from 'react'
import { Button, ButtonGroup } from '@mui/material'
import map from 'lodash/map'
import themeColors from '@layers-frontend/commons/styles/themeColors'
import withTranslator from '../HOCComponents/withTranslator'
import isEqual from 'lodash/isEqual'
import styled from 'styled-components'

const buttonStyle = {
  color: themeColors.whiteColor,
  borderColor: themeColors.whiteColor,
  background: themeColors.transparent,
  '&:hover': {
    borderColor: themeColors.whiteColor,
    background: themeColors.blueLightGrey
  },
  '&.Mui-disabled': {
    color: themeColors.grayColor,
    borderColor: themeColors.grayColor
  }
}
const selectedButtonStyle = {
  background: themeColors.blueLightGrey
}

// Pill look: a soft track where the selected option is a solid mint pill (exported for other MUI button groups).
// The tripled class outranks the ButtonGroup rules that square the inner corners and draw the borders.
export const pillGroupStyle = {
  background: themeColors.whiteTransparent01,
  borderRadius: '999px'
}
export const pillButtonStyle = {
  '&&&': {
    textTransform: 'capitalize',
    color: themeColors.whiteTransparent08,
    borderColor: themeColors.transparent,
    borderRadius: '999px'
  },
  '&&&:hover': {
    background: themeColors.whiteTransparent01,
    borderColor: themeColors.transparent,
    color: themeColors.whiteColor
  },
  '&&&.Mui-disabled': {
    color: themeColors.grayColor,
    borderColor: themeColors.transparent
  }
}
export const pillSelectedButtonStyle = {
  '&&&, &&&:hover': {
    background: themeColors.mintColor,
    color: themeColors.deepblueColor3
  }
}
const TextLabel = styled.p`
  color: white;
  font-size: 12px;
`
const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
`
const StyledButtonGroup = ({ t, selectedButton, onChange, buttons, textLabel = null, fullWidth = true, disabled, pill = false }) => {
  const [baseStyle, selectedStyle] = pill ? [pillButtonStyle, pillSelectedButtonStyle] : [buttonStyle, selectedButtonStyle]
  return (
    <Wrapper>
      {textLabel && <TextLabel>{textLabel}</TextLabel>}
      <ButtonGroup
        size="small"
        aria-label="small button group"
        fullWidth={fullWidth}
        onClick={disabled ? null : onChange}
        sx={pill ? pillGroupStyle : undefined}
      >
        {map(buttons, button => (
          <Button
            disabled={disabled}
            value={button.value}
            sx={[baseStyle, isEqual(button.value, selectedButton) && selectedStyle]}
            key={button.value}
            data-testid={button['data-testid']}
          >
            {t(button.label)}
          </Button>
        ))}
      </ButtonGroup>
    </Wrapper>
  )
}

export default withTranslator(StyledButtonGroup)
